'use strict';

const gtm = require('../../modules/google').tagManager;

const updatePDPHandler = require('./updatePDPHandler'),
    damHelper = require('../../dam/dam-helper'),
    easter = require('../../easter/easter');

const variationsEvents = {
    onNotSelectedOption: $.Event('stickyAddToCart.onNotSelectedOption'),
    onOptionChange: $.Event('selectric.setOutOfStockClass'),
    onSwatchChange: $.Event('selectric.filterVisibleOptionsAndSetOutOfStockClass')
};

// Used currently only for the Scrub Bar PDP to prevent multiple clicks on
// variantion buttons before new main image is changed in slider.
// Ticket: https://rituals.atlassian.net/browse/DL-24789
let blockEvent = false;

const pushScrubData = (event) => {
    event = event || 'pdp_swatch_interaction';

    const dataLayerObject = {
        event: event
    };

    gtm.pushDataLayerEvent(dataLayerObject);
};

const updateEasterData = (easterData) => {
    const urlParams = {
        skipAnimation: true
    };
    urlParams[easterData.variationAttribute] = easterData.variationAttributeValue;
    updatePDPHandler.updateStateAndUrlParams(urlParams);
    updatePDPHandler.updateImages(easterData.urlImages, function() {
        updatePDPHandler.updateBlocksWithColor('.js-product-details-container', easterData.colorClass, easterData.allColorClasses);
    });
    updatePDPHandler.updateAncientRituals(easterData.ancientRitual);
    updatePDPHandler.updateShortDescription(easterData.shortDescription);
    updatePDPHandler.updateTitle(easterData.title);
    updatePDPHandler.updateRitualsIcon(easterData.ritualIconUrl);
    updatePDPHandler.updateAddToCartButton(easterData.addToCartUrl);
    easter.updateARbuttons(easterData.src, easterData.iosSrc, easterData.description);
    easter.updateARmodel(easterData.src, easterData.iosSrc);
    updatePDPHandler.updateProductDetailImage(easterData.productDetailImageUrl);
    updatePDPHandler.updateInfoTitle(easterData.detailTitle);
    updatePDPHandler.updateInfoText(easterData.detailDescription);
    updatePDPHandler.updateProductLifestyleImage(easterData.ingredientsBackgroundImageUrl);
    updatePDPHandler.updateClaimableIngredients(easterData.claimableIngredients);
    updatePDPHandler.updateBlocksWithColor('.js-product-ingredients-block', easterData.fullColorClass, easterData.allFullColorClasses);
    updatePDPHandler.updateHowToUseImage(easterData.howToUseImageUrl);
    updatePDPHandler.updateHowToUseText(easterData.howToUseText);
    updatePDPHandler.updateEasterARBlockImage(easterData.arImageUrl);
    updatePDPHandler.updateBlocksWithColor('.js-easter-ar-block', easterData.solidColorClass, easterData.allSolidColorClasses);
    updatePDPHandler.updateTabsIngredients(easterData.chemicalIngredients);
    updatePDPHandler.updateTabsDescription(easterData.usp);
    updatePDPHandler.updateTabsContents(easterData.boxContains);
    updatePDPHandler.updateStickyBarTitle(easterData.title);
    updatePDPHandler.updateStickyBarAncientRituals(easterData.ancientRitual);
    updatePDPHandler.updateStickyBarImage(easterData.stickyBarImage);
    updatePDPHandler.updateStickyAddToCartButton(easterData.stickyAddToCartUrl);
    $(document).trigger($.Event('easter.onSwatchChange'),[easterData.ritual]);
    easter.pushEvent(easterData.color);
};

function updatePrice(price) {
    $('span.js-price-range').html(price);
}

function updateInfoBlock(swatchElement) {
    const infoBlock = swatchElement.data('variationInfoBlock');

    updatePDPHandler.updateInfoTitle(infoBlock.title);
    updatePDPHandler.updateInfoText(infoBlock.description);
    updatePDPHandler.updateProductDetailImage(infoBlock.image);
    updatePDPHandler.updateUSPs(infoBlock.usps);
    updatePDPHandler.updateVideoSrc('details-video', infoBlock.videoSrc);
}

function updateScrubImages() {
    const variantId = $('.js-pdp-swatches-item.selected .js-pdp-swatches-image').data('variationId');
    const imageInSlide = $('.slick-slide:not(.slick-cloned) .js-product-thumbnail[data-variant-id="' + variantId + '"]');
    if (!imageInSlide) {
        return;
    }
    const slickSlide = imageInSlide.closest('.slick-slide');
    if (!slickSlide.hasClass('.slick-active')) {
        imageInSlide.closest('.js-pdp-scrub-slider').slick('slickGoTo', slickSlide.data('slickIndex'), false);
    }

    const $previewImage = $('.js-product-details-block .js-product-preview-image');
    $previewImage.attr('data-src', imageInSlide.data('primaryScrubImage'));
    damHelper.updateImages($previewImage.parent());
}

function swatchVariationChangeHandler(target, data) {
    const $parent = target.parent();
    if ($parent.hasClass('selected')) {
        return;
    }
    const skipImage = data && data.skipImage;
    const eventLabel = data && data.eventLabel;
    $parent.siblings().removeClass('selected');
    $parent.addClass('selected');

    const $swatchImage = target.find('.js-pdp-swatches-image');
    const easterData = $swatchImage.data('variation-easter-data');
    if (easterData && Object.keys(easterData).length) {
        updateEasterData(easterData);
        return;
    }

    const isScrub = $swatchImage.data('variation-is-scrub');
    if (isScrub) {
        blockEvent = true;
        pushScrubData(eventLabel);
    }

    const $dropdown = $('.js-pdp-custom-select');
    const samePrice = $dropdown.data('samePrice');
    const variationUrl = $swatchImage.data('variation-url');
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const entries = urlParams.entries();
    const urlParamsMap = {};
    for (const entry of entries) {
        urlParamsMap[entry[0]] = entry[1];
    }
    if (variationUrl) {
        window.history.replaceState({}, '', variationUrl);
        const paramsToRemove = [$swatchImage.data('variationAttribute')];
        updatePDPHandler.updateStateAndUrlParams(urlParamsMap, paramsToRemove);
    } else {
        urlParamsMap[$swatchImage.data('variationAttribute')] = $swatchImage.data('variationAttributeValue');
        updatePDPHandler.updateStateAndUrlParams(urlParamsMap);
    }

    if (!$dropdown.length || samePrice) {
        if (!skipImage) {
            updatePDPHandler.updateImages($swatchImage.data('variationUrlImages'), updateScrubImages);
        }

        updatePDPHandler.updateStickyBarImage($swatchImage.data('variationStickyBarImage'));
        updatePDPHandler.updateProductLifestyleImage($swatchImage.data('variationIngredientsBackgroundImageUrl'));
    }

    updateInfoBlock($swatchImage);
    updatePDPHandler.trimAndUpdateLongDescription($swatchImage.data('variationUsp'));
    updatePDPHandler.updateClaimableIngredient($swatchImage.data('variationClaimableIngredient'));
    updatePDPHandler.updateChemicalIngredients($swatchImage.data('variationChemicalIngredients'));
    updatePDPHandler.updateProductTitle($swatchImage.data('scrubTitle'));
    updatePDPHandler.updateFragrance($swatchImage.data('variationFragrance'));

    let addToCartUrl = $swatchImage.data('variationAddToCartUrl');
    let stickyAddToCartUrl = $swatchImage.data('variationStickyAddToCartUrl');

    if ($dropdown.length) {
        $(document).trigger(variationsEvents.onSwatchChange, $dropdown);
        const $selectedOption = $dropdown.children(':selected');
        const variationAttributeValue = $selectedOption.data('variationAttributeValue');
        if (variationAttributeValue) {
            const data = $swatchImage.data('variationUrls');

            if (!samePrice) {
                updatePageFromSelectedSize(data[variationAttributeValue]);
            }

            addToCartUrl = data[variationAttributeValue].addToCartUrl;
            stickyAddToCartUrl = data[variationAttributeValue].stickyAddToCartUrl;
        } else if (!samePrice){
            updatePDPHandler.updateImages($swatchImage.data('variationUrlImages'), updateScrubImages);
            updatePDPHandler.updateStickyBarImage($swatchImage.data('variationStickyBarImage'));
            updatePDPHandler.updateProductLifestyleImage($swatchImage.data('variationIngredientsBackgroundImageUrl'));
        }

        $dropdown.selectric('close');
    }
    updatePDPHandler.updateAddToCartButton(addToCartUrl);
    updatePDPHandler.updateStickyAddToCartButton(stickyAddToCartUrl);
    $('.js-pdp-options-dropdown').removeClass('error-field');
}

function dropdownVariationChangeHandler(target) {
    const $dropdown = $('.js-pdp-custom-select');
    const $selectedOption = $dropdown.children(':selected');
    if (target.data('selectedDropdownValue') === $selectedOption.val() || !$selectedOption.data('variationAddToCartUrl')) {
        return;
    }

    const samePrice = $dropdown.length && $dropdown.data('samePrice');
    let addToCartUrl = $selectedOption.data('variationAddToCartUrl');
    let stickyAddToCartUrl = $selectedOption.data('variationStickyAddToCartUrl');
    const $selectedSwatch = $('.js-pdp-swatches-item.selected');
    if ($selectedSwatch.length) {
        const $selectedSwatchImage = $selectedSwatch.find('.js-pdp-swatches-image');
        const variationAttributeValue = $selectedSwatchImage.data('variationAttributeValue');
        const data = $selectedOption.data('variationUrls');
        addToCartUrl = data[variationAttributeValue].addToCartUrl;
        stickyAddToCartUrl = data[variationAttributeValue].stickyAddToCartUrl;
        if (!samePrice) {
            updatePageFromSelectedSize(data[variationAttributeValue]);
        }
    }

    updatePDPHandler.updateAddToCartButton(addToCartUrl);
    updatePDPHandler.updateStickyAddToCartButton(stickyAddToCartUrl);
    target.data('selectedDropdownValue', $selectedOption.val());
    $('.js-pdp-options-dropdown').removeClass('error-field');
    $(document).trigger(variationsEvents.onOptionChange, $dropdown);
    $dropdown.selectric('close');
}

function updatePageFromSelectedSize(selectedElementData) {
    if (!selectedElementData) {
        return;
    }
    updatePrice(selectedElementData.price);
    updatePDPHandler.updateProductLifestyleImage(selectedElementData.ingredientsBackgroundImageUrl);
    updatePDPHandler.updateProductDetailImage(selectedElementData.productDetailImageUrl);
    updatePDPHandler.updateStickyBarImage(JSON.parse(selectedElementData.stickyBarImage));
    updatePDPHandler.updateImages(selectedElementData.urlImages, updateScrubImages);
}

function initEvents(){
    $(document).on('click.swatch', '.js-pdp-swatches-btn', function(e, data) {
        if (!blockEvent) {
            e.preventDefault();
            e.stopPropagation();
            swatchVariationChangeHandler($(this), data);
        }
    });

    $(document).on('mouseover', '.js-pdp-swatches-btn', function() {
        const $selectedSwatchImage = $(this).find('.js-pdp-swatches-image');
        const dynamicSwatchName = $selectedSwatchImage.length ? $selectedSwatchImage.data('variationName') : '';
        $('.js-pdp-swatches-name').text(dynamicSwatchName);
    });

    $(document).on('mouseout', '.js-pdp-swatches-btn', function() {
        const $selectedSwatchImage = $('.js-pdp-swatches-item.selected .js-pdp-swatches-image');
        const dynamicSwatchName = $selectedSwatchImage.length ? $selectedSwatchImage.data('variationName') : '';
        $('.js-pdp-swatches-name').text(dynamicSwatchName);
    });

    $(document).on('click', '.js-pdp-swatches-toggle', function() {
        const $swatchItem = $('.js-pdp-swatches-item');
        const $showSwatchesBtn = $('.js-pdp-swatches-show');
        const $hideSwatchesBtn = $('.js-pdp-swatches-hide');

        if ($swatchItem.hasClass('hidden')) {
            $swatchItem.toggleClass('visible');
        }
        $showSwatchesBtn.toggle();
        $hideSwatchesBtn.toggle();
    });

    $(document).on('change', '.js-pdp-custom-select', function() {
        dropdownVariationChangeHandler($(this));
    });

    $(document).on('click', '.js-select-option', function() {
        const $optionsDropdown = $('.js-pdp-options-dropdown');
        if ($optionsDropdown.length > 0) {
            $('.js-pdp-options-dropdown').addClass('error-field');
        }
    });

    $(document).on('slider.onAfterChange', '.js-slider', function() {
        blockEvent = false;
    });
}

function validateVariations(e) {
    const $swatches = $('.js-pdp-swatches-item');
    const $dropdown = $('.js-pdp-custom-select');
    if ($dropdown.length > 0 && $swatches.length > 0) {
        const $selectedOption = $dropdown.children(':selected');
        if (!$selectedOption.data('variationAddToCartUrl')) {
            $('.js-pdp-options-dropdown').addClass('error-field');
            e.preventDefault();
            e.stopPropagation();
            if ($(e.target).parents('.js-sticky-add-to-cart').length) {
                $(document).trigger(variationsEvents.onNotSelectedOption);
            }
            return false;
        }
    }
    return true;
}

module.exports.initEvents = initEvents;

module.exports.validateVariations = validateVariations;
